import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface CustomerPOStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    customerPO?: TypographyProps;
}

export const CustomerPOStyles: CustomerPOStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = CustomerPOStyles;

const CustomerPO: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.customerPO) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="customerPO">
                {translate("Order PO Number")}
            </Typography>
            <Typography {...styles.customerPO} aria-labelledby="customerPO">
                {order.customerPO}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomerPO,
    definition: {
        allowedContexts: ["WorkOrderDetailsPage", "OrderDetailsPage"] as any,
        group: "Order Details",
    },
};

export default widgetModule;
